import { dayjs } from '@studio/js-utils/time';
import { UserInviteDetails } from './invite-details.jsx';
import type { User } from './types.js';

/** GuestsTab component. */
export const GuestsTab = ({
  guests,
  onDelete,
  updateGuest
}: {
  guests: User[];
  onDelete: (guestEmail: string) => () => void;
  updateGuest: (email: string, update: Partial<User>) => void;
}) => {
  const activeGuests = guests.filter((v) => dayjs(v.expiration).isAfter(dayjs()));
  const inactiveGuests = guests.filter((v) => dayjs(v.expiration).isBefore(dayjs()));

  return (
    <div className='mt-18 flex flex-col gap-12'>
      {guests.length === 0 ? (
        <div>
          <h2>No active guests</h2>
          <div className='text-secondary'>Guests are users with expiration enabled</div>
        </div>
      ) : (
        <div className='flex flex-col gap-y-8'>
          {activeGuests.length > 0 && <h3>Active</h3>}
          {activeGuests.map((guest) => (
            <UserInviteDetails
              key={guest.email}
              onDelete={onDelete(guest.email)}
              onUpdate={(update: Partial<User>) => {
                updateGuest(guest.email, update);
              }}
              user={guest}
            />
          ))}

          {inactiveGuests.length > 0 && <h3 className='mt-16'>Expired</h3>}
          {inactiveGuests.map((guest) => (
            <UserInviteDetails
              key={guest.email}
              onDelete={onDelete(guest.email)}
              onUpdate={(update: Partial<User>) => {
                updateGuest(guest.email, update);
              }}
              user={guest}
            />
          ))}
        </div>
      )}
    </div>
  );
};
